var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.4375H10.3125L10.9375 5.9375H8.75V4.6875C8.75 4.04375 8.75 3.4375 10 3.4375H10.9375V1.3375C10.7337 1.31063 9.96437 1.25 9.15187 1.25C7.455 1.25 6.25 2.28562 6.25 4.1875V5.9375H4.375V8.4375H6.25V13.75H8.75V8.4375Z",
    fill: "#8A7C8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.62a77ce7f08559eb26a4d67d9cef2909.svg";
export { ForwardRef as ReactComponent };